<template>
  <div>
    <PageAllow
      controller="OrderMaterialAnalyze"
      action="orderService"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("orderService.detail") }}
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("orderService.DetailFields.order_code")}}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>{{ bill.order_code }} </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("orderService.DetailFields.shop", [$consts.shopName()])
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>{{ bill.shop ? bill.shop.shop_name : '' }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("orderService.DetailFields.created")}}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ bill.created | formatTime }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("orderService.DetailFields.order_service_charge") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}
                    {{ bill.order_service_charge | formatMoney}}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-data-table
        :headers="detailsHeaders"
        :items="bill.bill_details"
        multi-sort
        disable-pagination
        hide-default-footer
        :no-data-text="$t('orderCategoryFreight.DetailFields.DetailNoData')"
        class="elevation-2 px-4 mt-4"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("orderService.DetailFields.details") }}
            </v-toolbar-title>
            <v-spacer />
            <span class="secondary--text text-subtitle-2 font-weight-bold">
              （ {{ $t("orderService.DetailFields.detail_hint") }} ）
            </span>
            <span class="secondary--text text-subtitle-2 font-weight-bold">
              {{ $t("orderService.DetailFields.service_charge_total") }}
              {{ $t("Global.colon") }}
            </span>
            <span class="accent--text text-subtitle-2 font-weight-bold">
              {{ $t("Global.money")}}
              {{ bill.service_charge }}
            </span>
          </v-toolbar>
          <v-divider />
        </template>
        <template v-slot:item.standard_name="{ item }">
          <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
            {{ item.standard_name.slice(0, 12) + "......" }}
          </span>
          <span v-else>
            {{ item.standard_name }}
          </span>
        </template>
        <template v-slot:item.service_charge="{ item }">
          {{ $t("Global.money") }}{{ item.service_charge }}
        </template>
      </v-data-table>
    </v-sheet>
  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import Receipt from "@/api/receipt";
export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  data: () => ({
    panels: [0],
    bill: {},
  }),
  mounted() {
    this.getOrderServiceFromAPI();
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("orderService.ObjectName"),
          disabled: false,
          href: "/order-service",
        },
        {
          text: i18n.t("orderService.detail"),
          disabled: true,
        },
      ];
    },
    detailsHeaders: () => [
      {
        text: i18n.t("orderService.DetailFields.category_name"),
        align: "start",
        value: "category_name",
      },
      {
        text: i18n.t("orderService.DetailFields.material_code"),
        align: "start",
        value: "material_code",
      },
      {
        text: i18n.t("orderService.DetailFields.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("orderService.DetailFields.standard_name"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("orderService.DetailFields.service_charge"),
        align: "start",
        value: "service_charge",
      },
    ],
  },
  methods: {
    getOrderServiceFromAPI() {
      Receipt.fetchDetail({bill_code:this.$route.params.bill_code}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bill = response.data.billEntity;
          }
        }.bind(this)
      );
    },
  },
};
</script>